import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { GetMenuPosition, SetMenuPosition, SetMenuPositionSuccess, LogoutUser, LogoutUserSuccess} from './user-panel.action';
import { AuthenticationService } from '../../../../services/authentication.service';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { environment } from '../../../../../../../projects/administration/src/environments/environment';

export class PositionPanelModel {sidebarShown: any; topbarShown: any; }
export class StatePanelModel {sidebarShown: any; topbarShown: any; side: string; userstate: string; }

export interface IuserPanelStateModel {
    // userPanelState: string;
    userPanelState: StatePanelModel; // {sidebarShown: boolean, topbarShown: boolean, side: string, userstate: string}
}

@State<IuserPanelStateModel>({
    name: 'state',
    defaults: {
        userPanelState: {sidebarShown: false, topbarShown: false, side: '', userstate: ''}
    }
})

@Injectable()

export class UserPanelState {

    constructor(
                private router: Router,
                // tslint:disable: variable-name
                private _cookieService: CookieService,
                private _authenticationService: AuthenticationService,
                private _store: Store
                ) { }

    @Action(LogoutUser)
    logoutUser(
        context: StateContext<IuserPanelStateModel>,
        action: LogoutUser
     ) {
            this._authenticationService.logout();
            context.dispatch(new LogoutUserSuccess('OUT'));
    }

    @Action(LogoutUserSuccess)
    logoutUserSuccess(
        context: StateContext<IuserPanelStateModel>,
        action: LogoutUserSuccess
    ) {
        context.setState({
            userPanelState: {sidebarShown: false, topbarShown: false, side: '', userstate: ''}
        });
        this.router.navigate(['/login']);
        window.location.reload();
    }

    // Change menu position
    @Action(SetMenuPosition)
    setMenuPosition(
        context: StateContext<IuserPanelStateModel>,
        action: SetMenuPosition
     ) {
         context.dispatch(
            new SetMenuPositionSuccess(action.position)
          );
    }

    @Action(SetMenuPositionSuccess)
    setMenuPositionSuccess(
        context: StateContext<IuserPanelStateModel>,
        action: SetMenuPositionSuccess
    ) {
        const mposition = this._cookieService.get('action.payload') ;
        const position = this.menuVisibility(mposition);
        context.setState({
            // userPanelState: action.payload
            // tslint:disable-next-line: max-line-length
            userPanelState:  {sidebarShown: position.sidebarShown, topbarShown: position.topbarShown, side: mposition, userstate: action.payload }

        });

        this._cookieService.set( 'menuPosition', action.payload );
        window.location.reload();
    }

    // Read menu position
    @Action(GetMenuPosition)
    getMenuPosition(
        context: StateContext<IuserPanelStateModel>,
        action: GetMenuPosition
     ) {
         const mposition = this._cookieService.get('menuPosition') || environment.menuPosition;
         const position = this.menuVisibility(mposition);
         context.setState({
            userPanelState:  {sidebarShown: position.sidebarShown, topbarShown: position.topbarShown, side: mposition, userstate: ''}
        });

    }

    menuVisibility(menu_position: string): PositionPanelModel {
        const res = new PositionPanelModel(); // {sidebarShown: false, topbarShown: false, side: mposition, userstate: ''}

        switch (menu_position) {
          // top menu is visible
          case 'top':
              res.sidebarShown = false;
              res.topbarShown = true;
              break;

          // side menu is visible
          case 'side':
            res.sidebarShown = 'lg';
            res.topbarShown = false;
            break;

          // all menus are hidden
          case 'none':
            res.sidebarShown = false;
            res.topbarShown = false;
            break;

          // top menu
          default:
            res.sidebarShown = 'lg';
            res.topbarShown = false;
        }
        return res;
      }

}
